import React from "react";
import { DevWorkData } from "../DevWorkData.jsx";
import line5 from "../DevWorkimages/Line5.png";
import straightLine from "../DevWorkimages/strtLine.png";
import trophy from "../DevWorkimages/trophy.png";

const DevWorkMap = () => {
  const evenImageCount = 0;
  const oddimageCount = 0;

  return (
    <div
      className="
        px-4 lg:mx-auto lg:relative
        lg:flex-col lg:columns-3
        max-w-[1600px] 2xl:max-w-[1750px]
      "
    >
      {DevWorkData.map((x, i) => (
        <div
          key={i}
          className={`
            ${x.id % 2 === 0 ? "lg:ms-24" : ""}
            ${x.id % 2 === 0 ? "lg:relative" : ""}
            ${x.id % 2 === 1 ? "lg:relative" : ""}
            border border-gray-300 rounded-xl cursor-pointer
            mb-5 lg:mb-24 px-3 lg:px-0
            w-full sm:w-[90%] md:w-[80%] lg:w-[299px]
            h-auto lg:h-40
            transition-all duration-300 hover:shadow-md
          `}
        >
          {/* === Card Content === */}
          <div className="py-4 lg:ps-5">
            <div className="lg:flex lg:gap-[10px]">
              <p className="text-[#c6477f] text-[18px] font-[700]">
                #{x.id}
              </p>
              <p className="font-[700] lg:h-[22px] text-[#1a202c] text-[18px]">
                {x.title}
              </p>
            </div>
            <p className="leading-5 pt-[15px] text-[14px] font-[400] text-[#718096]">
              {x.description}
            </p>
          </div>

          {/* === Connecting lines (only on desktop) === */}
          {x.id % 2 === 0 && evenImageCount < 3 && (
            <img
              src={straightLine}
              className="
                hidden lg:block absolute
                top-[-46px] left-36
                xl:left-40
                2xl:left-44
              "
              alt="straightLine"
            />
          )}
          {x.id % 2 === 1 && oddimageCount < 3 && (
            <img
              src={straightLine}
              className="
                hidden lg:block absolute
                top-[179px] left-[150px]
                xl:left-[170px]
                2xl:left-[190px]
              "
              alt="straightLine"
            />
          )}
        </div>
      ))}

      {/* === Main Horizontal Line === */}
      <img
        src={line5}
        className="
          hidden lg:block absolute
          left-0 top-52
          w-[1100px] xl:w-[1250px] 2xl:w-[1400px]
          max-w-full
        "
        alt="main line"
      />

      {/* === Trophy === */}
      <img
        src={trophy}
        alt="trophy"
        className="
          hidden lg:block absolute
          top-[188px] right-[-40px]
          xl:right-[-20px]
          2xl:right-[80px]
          w-[55px] xl:w-[60px] 2xl:w-[65px]
        "
      />
    </div>
  );
};

export default DevWorkMap;
